import type { ID } from '@/types/common';
import type { PaginatedResponse } from '@/types/responses';
import type { FullSource } from '@/types/source';
import { StreamOptions, StreamCallbacks } from '@/types/stream';

export enum ThumbnailSize {
    DEFAULT = 'default',
    MQ = 'mq',
    HQ = 'hq',
    MAXRES = 'maxres',
}

export enum SpriteLevel {
    SD = 'sd',
    HD = 'hd',
}

type FlirRecordingParameters = {
    cameraGuid: string;
    deviceId: string;
    startTime: Date | undefined;
    endTime: Date | undefined;
};

type StreamFunctionParams = {
    options: StreamOptions;
} & StreamCallbacks;

export type CameraValidationSuccess = {
    isValid: true;
    codec: string;
    resolution: [number, number];
    fps: number;
    durationSeconds: number;
    snapshotBase64: string;
};

export type CameraValidationFailure = {
    isValid: false;
    errorType: string;
    errorMessage: string;
};

export type CameraValidationResponse =
    | CameraValidationSuccess
    | CameraValidationFailure;

export interface CameraApiResponse {
    id: string;
    createdAt: number;
    updatedAt: number;
    name: string;
    streamUrl: string;
    username: string | null;
    password: string | null;
    userId: string;
    sourceId: string;
}

export { type FlirRecordingParameters, type StreamFunctionParams };

export type FolderVisibility = 'private' | 'organization';

export type FolderOwnership = 'owned' | 'shared';

export interface SourceFolder {
    id: ID;
    createdAt: number;
    updatedAt: number;
    name: string;
    userId: ID;
    sourceCount?: number;
    isOwner: boolean;
    isShared: boolean;
}

export interface SourceFolderChildren {
    sources: FullSource[];
}

export interface SourceFolderListResponse extends PaginatedResponse<SourceFolder> {
    totalSourcesCount: number;
}

export interface CreateSourceFolderPayload {
    name: string;
    visibility?: FolderVisibility;
}

export interface UpdateSourceFolderPayload {
    name: string;
    visibility?: FolderVisibility;
}

export interface SourceFolderMembershipPayload {
    sourceIds: string[];
}

export interface QuerySuggestionResponse {
    enhancedText: string;
}
export interface SourceFolderMembershipChanges {
    add: string[];
    remove: string[];
    selection: BulkSelectionPayload;
}

export interface BulkSelectionPayload {
    ids?: string[];
    selectAll?: boolean;
    selectedAt?: number;
    excludeIds?: string[];
}

export interface BulkDeleteResult {
    deleted: number;
    failed: number;
    inProgress: boolean;
}
